import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { getGroupByIdQueryOptions } from '@/core/components/sites/propertyQueryOptions'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/group/$groupId/edit-group/'
)({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Editor'] ||
      auth.user?.role === Role['Blogger']
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({ context: { queryClient, auth }, params: { groupId } }) => {
    return queryClient.ensureQueryData(
      getGroupByIdQueryOptions(groupId!, auth.token!)
    )
  },
  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
})
